// NOTE: process.env will be replaced by actual object by Webpack
// NOTE: not all variables will be compiled, but those starting with REACT_APP_ should be there
const ENV = process.env;

// noinspection JSUnusedGlobalSymbols
export default ENV;
